import { Suspense } from 'react';

import { useRouteHandleComponent } from '../useRouteHandleComponent';

/**
 * Renders the component named "Filters" from the deepest matching route module's "handle" export.
 */
export function Filters() {
  const result = useRouteHandleComponent({ name: 'Filters' });

  if (result === undefined) {
    return null;
  }

  const { Component: RouteFilters } = result;

  return (
    <div>
      <Suspense fallback={null}>
        <RouteFilters />
      </Suspense>
    </div>
  );
}
